export const ERROR_MESSAGE_GENERIC = "Something went wrong. Please try again later.";

export const LOG_SOURCE = {
  Account: 0,
  MyMeals: 1,
  OrderFlow: 2,
};

export const LOG_LEVEL = {
  FATAL: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4,
  TRACE: 5,
};

export const ORDER_STATUS = {
  PENDING: 10,
  ACTIVE: 20,
  COMPLETE: 30,
  CANCELLED: 40,
  FUTURE: 50,
};

export const DISPLAY_NAME_TYPE = {
  SHORT_NAME: 0,
  LONG_NAME: 10,
};

export const IMAGE_DISPLAY_MODE = {
  DETAILS_OVERLAY: 0,
  IMAGE_PINNED_TOP: 10,
  NO_IMAGE: 20,
};

export const PRODUCT_TYPE = {
  OFF_MENU: "OffMenu",
};

//Screen sizes for Media Queries -> ChromeDevTools
const screenSize = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tabletS: "600px",
  tabletM: "768px",
  tabletL: "990px",
  laptopS: "1024px",
  laptopM: "1200px",
  laptopL: "1440px",
  desktop: "2560px",
};

export const deviceSize = {
  mobileS: `(max-width: ${screenSize.mobileS})`,
  mobileM: `(max-width: ${screenSize.mobileM})`,
  mobileL: `(max-width: ${screenSize.mobileL})`,
  mobileLandscape: `(max-height: ${screenSize.mobileL})`,
  tabletS: `(max-width: ${screenSize.tabletS})`,
  tabletM: `(max-width: ${screenSize.tabletM})`,
  tabletL: `(max-width: ${screenSize.tabletL})`,
  laptopS: `(max-width: ${screenSize.laptopS})`,
  laptopM: `(max-width: ${screenSize.laptopM})`,
  laptopL: `(max-width: ${screenSize.laptopL})`,
  desktop: `(max-width: ${screenSize.desktop})`,
  desktopL: `(max-width: ${screenSize.desktop})`,
};
export const primary_brand_color = "--primary-brand-color";
export const secondary_brand_color = "--secondary-brand-color";

export const heading_font_family = "--heading-text-font-family";
export const heading_font_style = "--heading-text-font-style";
export const heading_font_weight = "--heading-text-font-weight";
export const heading_font_size = "--heading-text-font-size";
export const heading_font_color = "--heading-text-color";
export const heading_font_alignment = "--heading-text-align";
export const heading_font_text_transform = "--heading-text-transform";

export const body_font_style = "--body-text-font-style";
export const body_font_family = "--body-text-font-family";
export const body_font_weight = "--body-text-font-weight";
export const body_font_color = "--body-text-color";

/*Primary Button Styles*/
export const primary_button_font_family = "--button-primary-font-style";
export const primary_button_font_weight = "--button-primary-font-weight";
export const primary_button_font_size = "--button-primary-font-size";
export const primary_button_font_text_transform = "--button-primary-text-transform";
export const primary_button_font_color = "--button-primary-text-color";
export const primary_button_background_color = "--button-primary-background-color";
export const primary_button_border_color = "--button-primary-border-color";
export const primary_button_border_width = "--button-primary-border-width";

/*Primary Button Hover Styles*/
export const primary_button_hover_font_family = "--button-primary-hover-font-style";
export const primary_button_hover_font_weight = "--button-primary-hover-font-weight";
export const primary_button_hover_font_size = "--button-primary-hover-font-size";
export const primary_button_hover_font_text_transform = "--button-primary-hover-text-transform";
export const primary_button_hover_font_color = "--button-primary-hover-text-color";
export const primary_button_hover_background_color = "--button-primary-hover-background-color";
export const primary_button_hover_border_color = "--button-primary-hover-border-color";
export const primary_button_hover_border_width = "--button-primary-hover-border-width";

/*Secondary Button Styles*/
export const secondary_button_font_family = "--button-secondary-font-style";
export const secondary_button_font_weight = "--button-secondary-font-weight";
export const secondary_button_font_size = "--button-secondary-font-size";
export const secondary_button_font_text_transform = "--button-secondary-text-transform";
export const secondary_button_font_color = "--button-secondary-text-color";
export const secondary_button_background_color = "--button-secondary-background-color";
export const secondary_button_border_color = "--button-secondary-border-color";
export const secondary_button_border_width = "--button-secondary-border-width";

/*Secondary Button Hover Styles*/
export const secondary_button_hover_font_family = "--button-secondary-hover-font-style";
export const secondary_button_hover_font_weight = "--button-secondary-hover-font-weight";
export const secondary_button_hover_font_size = "--button-secondary-hover-font-size";
export const secondary_button_hover_font_text_transform = "--button-secondary-hover-text-transform";
export const secondary_button_hover_font_color = "--button-secondary-hover-text-color";
export const secondary_button_hover_background_color = "--button-secondary-hover-background-color";
export const secondary_button_hover_border_color = "--button-secondary-hover-border-color";
export const secondary_button_hover_border_width = "--button-secondary-hover-border-width";

export const mui_default_primary_color = "#90caf9";
export const mui_default_secondary_color = "#f48fb1";

export const default_success_color = "#29a80a";

/*Background Colors */
export const body_background_color = "#ffffff";
export const default_dialog_background_color = "#ffffff";
export const default_background_color = "#fafafa";

export const recipe_default_image = "DefaultImage.jpg";
export const product_default_image = "DefaultImage.jpg";
export const program_meal_default_image = "DefaultImage.jpg";
export const meal_bundle_default_image = "DefaultImage.jpg";
